import type { JournalItem } from "@nabla/api";

const transcrita = "A Nabla transcreveu a fala de um vídeo enviado para uma campanha nova.";
const falhou = "A transcrição de um vídeo falhou.";

export function journal(item: JournalItem): string | undefined {
  if (item.type === "fala-transcrita") return transcrita;
  return item.type === "fala-falhou" ? falhou : undefined;
}
